import { inject, Injectable } from '@angular/core';
import {
  getAddressCheck,
  getAddressCheckError,
  getAddressCheckSuccess,
} from '@essent/address';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map } from 'rxjs';

import * as AddressFormActions from '../../../old/address-form';
import { addressFormSelectorKey } from '../../../old/address-form';

@Injectable()
export class AddressFormEffects {
  private readonly actions$ = inject(Actions);

  doAddressCheck$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AddressFormActions.getAddressCheck),
      map(({ postcode, houseNumber, houseNumberAddition }) =>
        getAddressCheck({
          actionId: addressFormSelectorKey,
          payload: { postcode, houseNumber: houseNumber + houseNumberAddition },
        })
      )
    )
  );

  handleAddressCheckSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getAddressCheckSuccess),
      filter((params) => params.actionId === addressFormSelectorKey),
      map((params) => AddressFormActions.getAddressSuccess(params.payload))
    )
  );

  handleAddressCheckError$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getAddressCheckError),
      filter((params) => params.actionId === addressFormSelectorKey),
      map((params) =>
        AddressFormActions.getAddressError({ response: params.payload })
      )
    )
  );
}
